import { isDefaultCountry, isDefaultLanguage } from '@dashboard/junk-drawer/utils/i18n-defaults';
import { useAppSubdomain } from '@square/environment-utils/domain-separation';
const SQUARE_URL_PREFIX = useAppSubdomain() ? '//app.squareup.com/' : '//squareup.com/';
const SHOP_PREFIX = '/shop/hardware/';
const ENCODED_UTMS = '%3Futm_source%3Ddashboard%26utm_medium%3Dreferral';
const REMOVE_DOUBLE_SLASHES = /([^:]\/)\/+/g;
export function buildPath(...args) {
  return args.filter(Boolean).join('/').replace(REMOVE_DOUBLE_SLASHES, '$1');
}
export function getLocalePath(countryCode, locale) {
  // TODO(gabriel) figure out a way to pass full language information to public web
  const language = locale?.split('-')[0];
  if (!countryCode || isDefaultCountry(countryCode) && isDefaultLanguage(language)) {
    return '';
  }
  return `${countryCode.toLowerCase()}/${language}/`;
}
export function i18nLink(path, countryCode, language) {
  return buildPath(SQUARE_URL_PREFIX, getLocalePath(countryCode, language), path);
}
export function shopI18nLink(path, countryCode, language) {
  return buildPath(SQUARE_URL_PREFIX, path, getLocalePath(countryCode, language));
}
export function shopProductI18nLink(sqProductKey, countryCode, language) {
  return buildPath(SHOP_PREFIX, getLocalePath(countryCode, language), '/p/', btoa(sqProductKey));
}
export function shopProductI18nLinkWithTracking(sqProductKey, countryCode, language) {
  const basePath = `/t/f_solidshop/d_dashboard/l_${countryCode.toLowerCase()}/dt_web/pr_${sqProductKey}`;
  const routeParam = `?route=${shopProductI18nLink(sqProductKey, countryCode, language)}${ENCODED_UTMS}`;
  return `${basePath}${routeParam}`;
}